import * as React from "react";
import VideoSection from "components/PeerRecognition/VideoSection/VideoSection";
import Loader from "components/Loader";
import classNames from "classnames";
import Scrollbar from "react-scrollbars-custom";
// import TinySlider from "tiny-slider-react";
// import 'tiny-slider/dist/tiny-slider.css';

function OutroVideos({
  loading,
  outroVideos,
  formik,
  loaderStyle,
  handleSelectVideo,
}) {
  // const styles = {
  //   fontFamily: "sans-serif",
  //   textAlign: "center"
  // };

  // const settings = {
  //   lazyload: true,
  //   nav: false,
  //   mouseDrag: true,
  //   loop: true,
  //   items: 3,
  //   gutter: 5,
  //   startIndex: 0,
  //   autoWidth: true,
  //   speed: "100ms"
  // responsive: {
  //   640: {
  //     edgePadding: 20,
  //     gutter: 20,
  //     items: 2
  //   },
  //   700: {
  //     gutter: 30
  //   },
  //   900: {
  //     items: 3
  //   }
  // }

  // };

  return (
    <React.Fragment>
      <div className="col-12 outro-section on-web">
        <div className="d-flex justify-content-center mb-2 title">
          <span className="videoTitle">Choose an outro video</span>
        </div>
        <Scrollbar style={{ height: "150px" }}>
          <div className="videos">
            <div className="row videosRow">
              {loading && (
                <div style={loaderStyle}>
                  <Loader width={40} height={40} />
                </div>
              )}
              {!loading &&
                outroVideos?.length > 0 &&
                outroVideos.map((video) => (
                  <div key={video.id} className="col-6 outro">
                    <VideoSection
                      videoURL={video.url}
                      thumbnail={video.thumbnail}
                      videoType={video.type}
                    />
                    <div
                      className={classNames({
                        check:
                          formik.values.outro_id === video.id ? true : false,
                        circle: true,
                      })}
                      onClick={() => handleSelectVideo(video.id, "outro_id")}
                    ></div>
                  </div>
                ))}
            </div>
          </div>
        </Scrollbar>
      </div>
      {/* <div className="on-mobile" style={styles} >
        {!loading &&
          outroVideos?.length > 0 &&
          <TinySlider settings={settings}>{
            outroVideos.map((video) => (
              <div key={video.id} className="col-6 outro">
                <VideoSection videoURL={video.url} videoType={video.type} />
                <div className={classNames({
                  check: formik.values.outro_id === video.id ? true : false,
                  circle: true,
                })}
                  onClick={() => handleSelectVideo(video.id, "outro_id")}
                ></div>
              </div>
            ))
          }
          </TinySlider>
        }
      </div> */}
    </React.Fragment>
  );
}

export default OutroVideos;
